module.exports = __webpack_public_path__ + "static/assets/aceaf9931208c7738a98c332e8a04f42.png";